import { Steps } from 'antd';
import type { StepsComponentProps } from './stepsComponent.types';
import './stepsComponent.scss';

/**
 * Progress indicator listing the create-study wizard steps down the left side of the page. Renders a vertical antd Steps whose current index is the one-based step converted to zero-based, with one item title per entry of the titles array.
 *
 * @param titles - Step descriptors whose name supplies each step title.
 * @param step - One-based index of the active wizard step.
 * @returns Vertical steps element for the wizard.
 */
const StepsComponent = ({ titles, step }: StepsComponentProps) => (
  <Steps
    direction="vertical"
    current={step - 1}
    className="new-study-step"
    items={titles.map((item: any) => ({
      title: item.name,
    }))}
  />
);

export default StepsComponent;
